import { useQuery } from "@tanstack/react-query"

import codeValueApi from "./codeValueApi"

const usePrefectureQuery = () => {
  const key = "codeValueApi.getPrefecture"
  const { data = [] } = useQuery([key], codeValueApi.getPrefecture, {
    select: (result) => (result.isSuccess ? result.data : []),
  })

  return data
}

export default usePrefectureQuery
